import { Fragment, useState } from 'react';

import _ from 'lodash';

import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import PropTypes from 'prop-types';

import { FadeInAnimation } from '../../shared';

const RoomTypeBuildingAmenities = (props) => {
    const { selectedRoomType, roomContentCMS } = props;
    const buildingAmenities = _.get(selectedRoomType, 'buildingAmenities');
    const buildingAmenityIcons = _.get(roomContentCMS, 'acf.icon');
    const defaultIconSrc = _.get(roomContentCMS, 'acf.default_amenity_icon.url');

    const renderAmenities = (type) => {
        return _.map(buildingAmenities, (amenity, index) => {
            if (index < 4 && type !== 'accordion') {
                return (
                    <Fragment key={index}>
                        <FadeInAnimation>
                            <div className='room-type-building-amenities-amenity-container'>
                                {renderAmenityIcon(amenity)}
                                <span className='room-type-building-amenities-amenity-text'>{amenity}</span>
                            </div>
                            <hr className='room-type-building-amenities-hr' />
                        </FadeInAnimation>
                    </Fragment>
                );
            }
            if (index >= 4 && type === 'accordion') {
                return (
                    <Fragment key={index}>
                        <FadeInAnimation>
                            <div className='room-type-building-amenities-amenity-container'>
                                {renderAmenityIcon(amenity)}
                                <span className='room-type-building-amenities-amenity-text'>{amenity}</span>
                            </div>
                            <hr className='room-type-building-amenities-hr' />
                        </FadeInAnimation>
                    </Fragment>
                );
            }
            return null;
        });
    };

    const renderAmenityIcon = (amenityFromAPI) => {
        let returnDefault = true;
        let imgSrc = null;
        _.forEach(buildingAmenityIcons, (icon) => {
            const iconSrc = _.get(icon, 'icon_image.url');
            const amenityId = _.get(icon, 'amnenity_name');
            if (_.lowerCase(amenityId) === _.lowerCase(amenityFromAPI)) {
                returnDefault = false;
                imgSrc = iconSrc;
            }
        });
        if (returnDefault) {
            return <img src={defaultIconSrc} alt="homii-o" width={22} />;
        }
        return <img src={imgSrc} alt={amenityFromAPI} width={22} />;
    };

    const [expanded, setExpanded] = useState(false);
    const [text, setText] = useState('See More +');

    const handleAccordionChange = (value) => () => {
        setExpanded(!value);
        setText(value ? 'See More +' : 'See Less -');
    };

    return (
        <FadeInAnimation>
            <div id="building-amenities-section">
                <h3 className='room-type-building-amenities-header3'>Building Amenities</h3>
                {renderAmenities()}
                <div className='room-type-building-amenities-accordion-wrapper'>
                    <Accordion expanded={expanded} onChange={handleAccordionChange(expanded)} className='room-type-building-amenities-accordion'>
                        <AccordionSummary
                            aria-controls="panel1d-content"
                            id="building-ammenities-accordion-button"
                        >
                            <p className='room-type-building-amenities-accordion-button-text'>{text}</p>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className='room-type-building-amenities-accordion-container'>{renderAmenities('accordion')}</div>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </div>
        </FadeInAnimation>
    );
};

export default RoomTypeBuildingAmenities;

RoomTypeBuildingAmenities.propTypes = {
    selectedRoomType: PropTypes.object,
    roomContentCMS: PropTypes.object,
};

